import { useMutation, UseMutationResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { carrotClient } from "#/utils/CarrotClient"

const recentRequests = new Map<string, number>()
const DEDUPLICATION_WINDOW_MS = 1000

export type MemberActionTaken = {
  memberActionTaken: string
  metaData?: any
}

function deDuplication(memberActionTaken: MemberActionTaken): boolean {
  const requestKey = `${memberActionTaken.memberActionTaken}-${JSON.stringify(memberActionTaken.metaData || {})}`
  const now = Date.now()
  const lastRequestTime = recentRequests.get(requestKey)

  // If the request was made recently, return true
  if (lastRequestTime && now - lastRequestTime < DEDUPLICATION_WINDOW_MS) return true

  // Track this request
  recentRequests.set(requestKey, now)

  // Cleanup old entries
  setTimeout(() => {
    recentRequests.delete(requestKey)
  }, DEDUPLICATION_WINDOW_MS)

  // If the request was not made recently, return false
  return false
}

export function useMemberActionTracking(): UseMutationResult<void, ResponseError, MemberActionTaken> {
  return useMutation<void, ResponseError, MemberActionTaken>(
    (memberActionTaken: MemberActionTaken) => {
      const isDuplicateRequest = deDuplication(memberActionTaken)
      return isDuplicateRequest
        ? Promise.resolve()
        : carrotClient.createMemberAction(memberActionTaken.memberActionTaken, memberActionTaken.metaData)
    },
    {
      retry: false
    }
  )
}
